import type { AalExportPayload, AalView } from "../aalV2";
import { useAalExport } from "../aalV2";

export type DownloadAALAllPayload = AalExportPayload & {
  event_category?: string;
  action_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  source_ip?: string;
  target_user_id?: string;
  username?: string;
};

export const useDownloadAALAllTable = (view: AalView) =>
  useAalExport("all", view);
